import * as singleSpa from "single-spa";
import { runScript } from "./utils";

const loadReactApp = async () => {
  await runScript(window.URL_MF_LEXON);
  return window.lexon;
};

const activityFunction = location => location.pathname.startsWith("/");

export const registerLexonApp = () => {
  if (!singleSpa.getAppNames().includes("lexon-app")) {
    singleSpa.registerApplication("lexon-app", loadReactApp, activityFunction);
  }
};